import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { CheckboxComponent } from '@core/components/checkbox/checkbox.component';
import { SFormFieldComponent } from '@core/components/s-form-field/s-form-field.component';
import { SessionService } from '@core/services/session.service';
import { SvgIconComponent } from 'angular-svg-icon';
import { Field, form, required } from '@angular/forms/signals';
import { AffiliatesService } from '@features/affiliates/services/affiliates.service';
import { ModalService } from '@features/modals/services/modal.service';
import { ToastrService } from 'ngx-toastr';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-affiliates-claim-modal',
  imports: [
    CheckboxComponent,
    SvgIconComponent,
    Field,
    SFormFieldComponent,
    RouterLink,
  ],
  templateUrl: './affiliates-claim-modal.component.html',
  styleUrl: './affiliates-claim-modal.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AffiliatesClaimModalComponent {
  public readonly sessionService = inject(SessionService);
  public readonly affiliatesService = inject(AffiliatesService);
  private readonly modalService = inject(ModalService);
  private readonly toastrService = inject(ToastrService);

  codeModel = signal<{ code: string }>({
    code: '',
  });

  codeForm = form(this.codeModel, (schemaPath) => {
    required(schemaPath.code, { message: 'Code is required' });
  });

  codeFormApiError = signal<string | null>(null);

  public async handleClaimAffiliateCode(event: Event) {
    event.preventDefault();
    this.codeFormApiError.set(null);
    try {
      const message = await this.affiliatesService.redeemReferralCode(
        this.codeForm().value().code
      );

      if (message) {
        this.toastrService.success(message);
        this.affiliatesService.userStatsResource.reload();
        this.modalService.close();
      }
    } catch (error: any) {
      this.codeFormApiError.set(error);
    } finally {
    }
  }

  public async refreshBalance() {
    const res = await this.affiliatesService.refreshBalance();
    console.log(res);
  }

  public async claimBalance() {
    try {
      const res = await this.affiliatesService.claimBalance();
      this.toastrService.success(`You successfully claimed ${res} coins`);
      this.sessionService.changeBalanceType('bonus');
    } catch (error: any) {}
  }

  public closeModal() {
    this.modalService.close();
  }
}
